<!-- 本科学员-列表页-页面级 -->
<template>
  <div class='mentee-list'>
    <h3>Mentee List</h3>
    <ul class='clearfix'
        v-if='menteeData.length > 0'>
      <li class='fl'
          v-for='item in menteeData'
          :key='item.menteeNum'
          @click="goDetail(item)">
        <img v-if='item.menteeAvaurl'
             :src='item.menteeAvaurl'
             alt='head sculpture' />
        <img v-else
             src='https://res.zailairen.com/tech/msp/mentor-avatar.svg'
             alt='head sculpture' />
        <p>{{item.menteeEnName}}</p>
      </li>
    </ul>
    <no-mentee v-if='menteeData.length === 0' />
  </div>
</template>

<script>
import noMentee from './components/no-mentee'
import menteeServie from '@/api/undergraduate/mentee'

export default {
  name: '',
  components: {
    noMentee
  },
  data () {
    return {
      // 学员列表
      menteeData: []

    }
  },
  computed: {},
  mounted () {
    this.getMenteeList()
  },
  methods: {
    // 获取学员列表
    getMenteeList () {
      menteeServie.menteeList().then(res => {
        this.menteeData = res.data.model
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 查看详情
    goDetail (item) {
      this.$router.push({
        path: `/undergraduate/mentee/${item.menteeNum}`
      })
    }
  }
}
</script>
<style lang='less' scoped>
.clearfix {
  *zoom: 1;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.fl {
  float: left;
}
.mentee-list {
  width: 1240px;
  padding: 40px 20px;
  margin: 0 auto;
  h3 {
    font-size: 18px;
    color: #4aa6ff;
    letter-spacing: 0;
  }
  li {
    width: 220px;
    height: 230px;
    background: #ffffff;
    box-shadow: 0 4px 8px 0 #e9f0fa;
    border-radius: 8px 8px 0 0;
    margin: 20px 38px;
    padding: 40px 20px;
    cursor: pointer;
    border-bottom: 4px solid #4aa6ff;
    img {
      display: block;
      width: 80px;
      height: 80px;
      margin: 0 auto;
      border: none;
    }
    p {
      font-size: 18px;
      color: #323c47;
      letter-spacing: 0;
      text-align: center;
      padding-top: 40px;
    }
  }
}
</style>
